var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21.921,
    viewBox: "0 0 21 21.921",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.039)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 17)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12-2H6A1,1,0,0,0,5-1,1,1,0,0,0,6,0h6a2,2,0,0,0,2-2V-15.959a1,1,0,0,0-1.485-.875l-2.463,1.365L7.939-16.592a2,2,0,0,0-1.879,0L3.948-15.468,1.485-16.834A1,1,0,0,0,0-15.959V-11a1,1,0,0,0,1,1,1,1,0,0,0,1-1v-3.262l1.084.6.114.054a2,2,0,0,0,1.68-.092L7-14.827,9.121-13.7a2,2,0,0,0,1.68.092l.114-.054,1.084-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1-2A1,1,0,0,0,0-1,1,1,0,0,0,1,0H4A1,1,0,0,0,5-1,1,1,0,0,0,4-2Z",
    transform: "translate(5 -5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1-2A1,1,0,0,0,0-1,1,1,0,0,0,1,0H4A1,1,0,0,0,5-1,1,1,0,0,0,4-2Z",
    transform: "translate(5 -9)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.515,16.834l-2.463-1.365L7.939,16.592a2,2,0,0,1-1.878,0L3.948,15.468,1.485,16.834A1,1,0,0,1,0,15.959V2A2,2,0,0,1,2,0H12a2,2,0,0,1,2,2V15.959a1,1,0,0,1-1,1A.991.991,0,0,1,12.515,16.834Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1,2A1,1,0,0,1,1,0H5A1,1,0,0,1,5,2Z",
    transform: "translate(4 5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1,2A1,1,0,0,1,1,0H5A1,1,0,0,1,5,2Z",
    transform: "translate(4 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatch);
export default __webpack_public_path__ + "static/media/batch.1c70c10cfd98e5dad0df328db45e9eb8.svg";
export { ForwardRef as ReactComponent };